var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",on:{"click":function($event){return _vm.$router.push({name: 'home'})}}},[_c('img',{attrs:{"src":_vm.logo}})])}
var staticRenderFns = []

export { render, staticRenderFns }